module.exports = __webpack_public_path__ + "img/example-interactive-kiosk-wayfinding.2dec446a.webp";